export { CustomError } from './components/Error/Error';

export { ProfileLayout } from './components/Profile/ProfileLayout';

export { ArticlePageTemplate } from './components/Article/ArticlePageTemplate';
export { AuthorTemplate } from './components/Author/AuthorTemplate';

export type { ArticlePageProps } from './components/Article/entities';
export type { AuthorTemplateProps } from './components/Author/AuthorTemplate';
